module.exports = __webpack_public_path__ + "media/time-management_en_ipad_new.e3566b65.mp4";